interface DateTimeComponents {
  date: string | null;
  hour: string | null;
}

export const formatDateTime = ({ date, hour }: DateTimeComponents): string => {
  if (!date || !hour) return '';

  try {
    const dateObj = new Date(date);
    dateObj.setHours(parseInt(hour));
    dateObj.setMinutes(0);
    dateObj.setSeconds(0);

    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');
    const year = dateObj.getFullYear();

    return `${month}/${day}/${year}, ${hour}:00:00`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

// Example usage in component:
export const getDateTimeFromRef = (
  dateRef: React.RefObject<HTMLInputElement>,
  selectedHour: string
): string => {
  if (!dateRef.current?.value || !selectedHour) return '';

  return formatDateTime({
    date: dateRef.current.value,
    hour: selectedHour,
  });
};
